export const ITEM_NOTE_MAX_LENGTH = 255;
export const CART_NOTE_MAX_LENGTH = 1000;
